import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HANDOVER_TYPE_HO3_ID } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { Image } from 'src/app/interfaces/image';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { ImageService } from 'src/app/services/image.service';
import { HandoverImageComponent } from '../handover-image/handover-image.component';
import { SectionTouched } from '../shared/section-touched.class';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-well-integrity',
  templateUrl: './handover-detail-well-integrity.component.html',
  styleUrls: ['./handover-detail-well-integrity.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HandoverDetailWellIntegrityComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;
  @Input() isEngineerUser!: boolean;

  isLoading = false;
  isLoadingBarrierProblems = false;
  isLoadingTubingWearReports = false;
  barriersSchemaImages: Image[] = [];
  imageLimit = 1;
  hasPendingChangesBarrier = false;
  hasPendingChangesTubing = false;
  isHO3 = false;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    public handoverService: HandoverService,
    public imageService: ImageService,
    public dialogService: DialogService,
    public dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handover?.handoverId) {
      this.isHO3 = this.handover.handoverTypeId == HANDOVER_TYPE_HO3_ID;
      this.imageService.endpointUrl = `${environment.urlBackend}/dhoapi/handovers/${this.handover.handoverId}/well-integrity/barrier-schema`;
      this.getBarriersSchemaImages(this.handover.handoverId);
    }
  }

  /* Métodos para esquema de barreras */

  getBarriersSchemaImages(handoverId: number): void {
    this.isLoading = true;
    this.handoverService
      .getBarriersSchemaImages(handoverId)
      .subscribe((values: Image[]) => {
        this.barriersSchemaImages = values;
        this.isLoading = false;
      });
  }

  attachBarriersSchema(): void {
    if (this.handover?.handoverId) {
      const dialogRef = this.dialogService.openImageUploadDialog(
        this.handover.handoverId,
        'Adjuntar Esquema de Barreras',
        500,
        true
      );
      dialogRef.afterClosed().subscribe((image) => {
        if (undefined != image) {
          this.barriersSchemaImages.push(image);
        }
      });
    }
  }

  deleteBarriersSchema(image: Image, index: number): void {
    const dialogRef = this.dialogService.openConfirmDialog(
      'Esquema de Barreras',
      `¿Está seguro de que desea eliminar la imagen?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.isLoading = true;
        this.imageService.deleteImage(image).subscribe((boolean) => {
          this.barriersSchemaImages.splice(index, 1);
          this.isLoading = false;
        });
      }
    });
  }

  openBarriersSchema(image: Image): void {
    const dialogRef = this.dialog.open(HandoverImageComponent, {
      width: '700px',
      height: '600px',
      hasBackdrop: false,
      autoFocus: false,
      data: {
        image: image,
        title: 'Esquema de Barreras',
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('Esquema de barreras de pozo ha sido cerrado');
    });
  }

  onBarrierProblemsLoading(barriersAreLoading: boolean): void {
    this.isLoadingBarrierProblems = barriersAreLoading;
  }

  onTubingWearLoading(tubingWearIsLoading: boolean): void {
    this.isLoadingTubingWearReports = tubingWearIsLoading;
  }

  onSectionHasPendingChangesBarrier(hasPendingChanges: boolean): void {
    this.hasPendingChangesBarrier = hasPendingChanges;
    this.emitPendingChanges(hasPendingChanges || this.hasPendingChangesTubing);
  }

  onSectionHasPendingChangesTubing(hasPendingChanges: boolean): void {
    this.hasPendingChangesTubing = hasPendingChanges;
    this.emitPendingChanges(hasPendingChanges || this.hasPendingChangesBarrier);
  }
}
